var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublicComments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12745_595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12745_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 21.75H20.75V18.75H23.75V17.25H20.75V14.25H19.25V17.25H16.25V18.75H19.25V21.75ZM10.5 29.05V12.3C10.5 11.8 10.675 11.375 11.025 11.025C11.375 10.675 11.8 10.5 12.3 10.5H27.7C28.2 10.5 28.625 10.675 28.975 11.025C29.325 11.375 29.5 11.8 29.5 12.3V23.7C29.5 24.2 29.325 24.625 28.975 24.975C28.625 25.325 28.2 25.5 27.7 25.5H14.05L10.5 29.05ZM12 25.425L13.425 24H27.7C27.7833 24 27.8543 23.9707 27.913 23.912C27.971 23.854 28 23.7833 28 23.7V12.3C28 12.2167 27.971 12.1457 27.913 12.087C27.8543 12.029 27.7833 12 27.7 12H12.3C12.2167 12 12.146 12.029 12.088 12.087C12.0293 12.1457 12 12.2167 12 12.3V25.425ZM12 12.3V12V25.425V12.3Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicComments);
export default __webpack_public_path__ + "static/media/publicComments.4c9a7314cf3fce88562002e821d2783b.svg";
export { ForwardRef as ReactComponent };